<template>
  <div
    class="layout__component-container layout--padding-top-none layout--padding-bottom-none"
  >
    <table
      class="table dashboard__table-wrap layout--drop-shadow layout--block"
    >
      <caption class="layout--screen-reader-only">
        Timer list view
      </caption>
      <thead class="layout--screen-reader-only">
        <tr scope="col">
          Name
        </tr>
        <tr scope="col">
          Status
        </tr>
        <tr scope="col">
          End Date
        </tr>
        <!-- <tr scope="col">
          Impressions
        </tr> -->
        <tr scope="col">
          Actions
        </tr>
      </thead>
      <tbody class="layout--block">
        <ListItem
          v-for="timer in timerList"
          :key="timer.widget.id"
          :timer="timer"
        />
      </tbody>
    </table>
  </div>
</template>

<script>
import ListItem from "./ListItem";

export default {
  name: "table-list",
  props: {
    timerList: Array,
  },
  components: {
    ListItem,
  },
};
</script>

<style></style>
